import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as homestayActions from '../../../../actions/homestayAction.js';
import * as homestayRateActions from './../../../../actions/homestayRateAction';
import Homestays from './Homestay';

const mapStateToProps = state => {
    return {
        homestayState: state.homestayReducer,
        homestayRateState: state.homestayRateReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListHomestays: (filters) => dispatch(homestayActions.getListHomestays(filters)),
        syncHomestayRates: (homestayId) => dispatch(homestayRateActions.syncHomestayRates(homestayId)),
        syncHomestayRatesAllHotels: () => dispatch(homestayRateActions.syncHomestayRatesAllHotels()),
        clearCache: (type) => dispatch(homestayActions.clearCache(type)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Homestays));
